export const getPaymentIcon = (paymentMethod) => {
  switch (paymentMethod) {
    case "online":
      return "ico-online-payment";
    case "package":
      return "ico-dollar-circle";
    case "offline":
      return "ico-offline-payment";
    default:
      return "ico-offline-payment";
  }
};

export const getPaymentIconClasses = (
  paymentMethod,
  styles,
  baseClasses = [],
  paymentStatus?: string,
) => {
  const classes = [
    ...baseClasses,
    styles[paymentMethod],
    "ico",
    getPaymentIcon(paymentMethod),
  ];

  if (paymentStatus) {
    if (paymentStatus === "failed" || paymentStatus === "past_due") {
      classes.push(styles.failed);
    } else if (paymentStatus !== "paid" && paymentStatus !== "payment_confirmed") {
      classes.push(styles.pending);
    }
  }

  return classes.filter(Boolean);
};
